import Axios from 'axios'

export const getBillingDetailsApi = async (params = {}) => {
  const { page = 1, limit = 10, sortField = 'createdAt', sortOrder = 'desc' } = params
  const response = await Axios.get('/billingDetails/getBillingDetails', {
    params: {
      page,
      limit,
      sortField,
      sortOrder,
    },
  })
  return response
}

export const resendBillingDetailEmailApi = async (id) => {
  const response = await Axios.post(`/billingDetails/resendBillingDetailEmail/${id}`)
  return response.data
}
